module.exports = __webpack_public_path__ + "img/search-gray.77d3b3e5.svg";